import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {GetCitiesListParam} from '../../services/getCitiesByFlow/types';
import {getCitiesByFlow} from '../../services/getCitiesByFlow/getCitiesByFlow';
import {CityProps} from '../../types';

export const useGetCitiesByFlowQuery = (params: GetCitiesListParam, enabled = true) =>
	useQuery<CityProps[]>({
		queryKey: [QUERY_KEYS.CITIES_BY_FLOW, params],
		queryFn: async ({signal}) => getCitiesByFlow({...params, signal}),
		enabled,
	});
